import React from 'react';

import '../icon-component.scss';

const PlusComponent = () => (
  <svg className="icon-component" viewBox="0 0 26 26">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1367.000000, -353.000000)">
        <g transform="translate(1352.000000, 338.000000)">
          <g transform="translate(15.000000, 15.000000)">
            <path d="M13,26 C12.448,26 12,25.4705455 12,24.8181818 L12,1.18181818 C12,0.529454545 12.448,0 13,0 C13.552,0 14,0.529454545 14,1.18181818 L14,24.8181818 C14,25.4705455 13.552,26 13,26" />
            <path d="M24.8181818,14 L1.18181818,14 C0.529454545,14 0,13.552 0,13 C0,12.448 0.529454545,12 1.18181818,12 L24.8181818,12 C25.4705455,12 26,12.448 26,13 C26,13.552 25.4705455,14 24.8181818,14" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

PlusComponent.displayName = 'PlusIcon';

export default PlusComponent;
